import ArrowRightIcons from '@/icons/ArrowRightIcons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'

export interface ModuleProps {
    icon: React.ReactNode
    value: string
    label: string
    className?: string
    excludeOptions?: string[]
    component: JSX.Element
}

const Module: React.FC<
    ModuleProps & { onChangeTab: (tab: string) => void }
> = ({ icon, label, value, className = '', onChangeTab }) => {
    const { t } = useTranslation()

    return (
        <div
            className={`
                bg-white rounded-lg border border-gray-200 p-5
                hover:border-blue-300 hover:shadow-sm transition-all duration-200 
                cursor-pointer group
                ${className}
            `}
            onClick={() => onChangeTab(value)}
        >
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="w-[34px] h-[34px] flex items-center justify-center bg-blue-50 rounded-full">
                        {React.createElement('div', {
                            className: 'w-6 h-6',
                            children: icon,
                        })}
                    </div>
                    <div>
                        <Typogaphy className="font-semibold text-primary capitalize">
                            {t(label)}
                        </Typogaphy>
                    </div>
                </div>
                <div
                    className="bg-bg-secondary-10 transition-colors h-9 w-9 rounded-md flex items-center justify-center"
                    onClick={() => onChangeTab(value)}
                >
                    <ArrowRightIcons className="w-6 h-4.5 text-secondary-100" />
                </div>
            </div>
        </div>
    )
}

export default Module
